export type SearchSession = {
  query?: string;
  categoryId?: number | null;
  countryCode?: string | null;
  cities?: string[];
  regions?: string[];
};

const SEARCH_SESSION_KEY = "premamarket.search";
const LEGACY_HOME_SEARCH_SESSION_KEY = "premamarket.homeSearch";
const LOCATION_SELECTION_VERSION = 2;

function normalizeSearchSession(value: unknown): SearchSession | null {
  if (!value || typeof value !== "object") return null;
  const item = value as Partial<SearchSession> & { locationSelectionVersion?: number };
  const hasExplicitLocation = item.locationSelectionVersion === LOCATION_SELECTION_VERSION;
  return {
    query: typeof item.query === "string" ? item.query : "",
    categoryId: typeof item.categoryId === "number" ? item.categoryId : item.categoryId === null ? null : null,
    countryCode: typeof item.countryCode === "string" ? item.countryCode : item.countryCode === null ? null : null,
    cities: hasExplicitLocation && Array.isArray(item.cities) ? item.cities.filter((city): city is string => typeof city === "string") : [],
    regions: hasExplicitLocation && Array.isArray(item.regions) ? item.regions.filter((region): region is string => typeof region === "string") : []
  };
}

function readSessionKey(key: string): SearchSession | null {
  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) return null;
    return normalizeSearchSession(JSON.parse(raw));
  } catch {
    return null;
  }
}

export function readSearchSession(): SearchSession | null {
  return readSessionKey(SEARCH_SESSION_KEY) ?? readSessionKey(LEGACY_HOME_SEARCH_SESSION_KEY);
}

export function writeSearchSession(value: SearchSession) {
  try {
    window.sessionStorage.setItem(SEARCH_SESSION_KEY, JSON.stringify({
      query: value.query ?? "",
      categoryId: value.categoryId ?? null,
      countryCode: value.countryCode ?? null,
      locationSelectionVersion: LOCATION_SELECTION_VERSION,
      cities: value.cities ?? [],
      regions: value.regions ?? []
    }));
  } catch {
    // Session persistence is optional; ignore private-mode/storage failures.
  }
}
